import { useMemo } from 'react';
import type { ScreenState } from '@hana/ui';

export interface MeeAccess {
  /** người đang xem (mã đăng nhập) */
  viewer: string;
  /** Ép trạng thái màn như prop `state` của board (xem thử / chụp ảnh). */
  force: ScreenState | null;
}

const STATES: readonly ScreenState[] = ['ready', 'loading', 'empty', 'error', 'noperm'];

/** TODO(A): người đăng nhập thật đến từ phiên Office 365 khi luồng A có; tạm đọc `?viewer=DAVID|MAITTN&state=…` như prop của board. */
export function useMeeAccess(search: string = typeof location === 'undefined' ? '' : location.search): MeeAccess {
  return useMemo(() => {
    const p = new URLSearchParams(search);
    const st = p.get('state') as ScreenState | null;
    return { viewer: p.get('viewer') ?? 'DAVID', force: st && STATES.includes(st) ? st : null };
  }, [search]);
}
